import { Spinner } from "@station/ui";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { RealtimeProvider } from "../lib/realtime-context.js";
import { bootstrapSession, useMe } from "../lib/session.js";

export const Route = createFileRoute("/sira-ekrani")({
  // Oturum yoksa girişe; girişten sonra aynı ekrana dönülür (TV'de bir kez giriş yapılır, oturum yenilenir).
  beforeLoad: async ({ location }) => {
    if (!(await bootstrapSession())) throw redirect({ to: "/giris", search: { redirect: location.href } });
  },
  component: QueueLayout,
});

/**
 * Kabuksuz, oturumlu tam ekran yerleşimi (Prompt 18 — yıkama sıra ekranı, TV). Menü, üst çubuk ve kısayollar YOKTUR;
 * yalnızca gerçek zamanlı bağlantı kurulur. Yetki ve bayrak denetimi sayfanın isteklerinde sunucudadır.
 */
function QueueLayout(): ReactElement {
  const { t } = useTranslation();
  const me = useMe();
  if (!me.data)
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner label={t("common.loading")} />
      </div>
    );
  return (
    <RealtimeProvider key={me.data.activeTenant?.id ?? "no-tenant"}>
      <Outlet />
    </RealtimeProvider>
  );
}
